import { request as queryRequest } from './reducers/query';
import { request as assignRequest } from './reducers/assign';
import { request as unassignRequest } from './reducers/unassign';
import { request as updateRequest } from './reducers/update';

// eslint-disable-next-line import/no-default-export
export default {
    TRANSACTIONS_QUERY_REQUEST: queryRequest,
    TRANSACTIONS_ASSIGN_REQUEST: assignRequest,
    TRANSACTIONS_UNASSIGN_REQUEST: unassignRequest,
    TRANSACTIONS_UPDATE_REQUEST: updateRequest,
};
